import React from 'react';
import { IIconProps } from '../../interfaces';
const TikTokIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 32 37"  fill="none" >
          <title>{props.title}</title>

          <path fillRule="evenodd" clipRule="evenodd" d="M22.758 0C23.3543 5.12872 26.2169 8.18643 31.1938 8.51172V14.2802C28.3096 14.5621 25.7831 13.6187 22.8447 11.8405V22.6292C22.8447 36.3347 7.90312 40.6177 1.89613 30.794C-1.96397 24.4725 0.399798 13.3802 12.7824 12.9356V19.0185C11.8391 19.1703 10.8307 19.4089 9.90907 19.7233C7.15496 20.6558 5.59357 22.4015 6.02729 25.4809C6.8622 31.3795 17.6835 33.1252 16.7835 21.5992V0.010843H22.758V0Z" fill="black"/>
     </svg>


  )
};

export default TikTokIcon;